import { Loading, PageableListV2Dto } from '@fleet-beat/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { DataSourceParams } from './data-source-params.model';

/* eslint-disable-next-line @typescript-eslint/no-explicit-any */
export interface PageableDataSourceV2<DataSource, Params extends DataSourceParams<any, any>> {
  reloadSubject: BehaviorSubject<Params | undefined>;
  loading: Loading;
  dataSource: DataSource;
  params$?: Observable<Params>;
  /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
  getData?: (params: Params) => Observable<PageableListV2Dto<any>>;
  /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
  getById?: (id: string) => Observable<any>;
}
